import useAppQuery from 'core/query-client/useAppQuery';
import { getUsers } from 'shared/api/users/http';

const useUsersQuery = () =>
  useAppQuery('users', getUsers, {
    cacheTime: Infinity,
    refetchOnMount: false
  });

export default useUsersQuery;
